import { legacyPlugins } from "/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/node_modules/.pnpm/@unhead+vue@3.3.1_@oxc-project+types@0.143.0_esbuild@0.28.2_lightningcss@1.33.0_oxc-par_94f9b45cf122501bd979709bdb60022b/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}